/**
 * Guide content for version 2.7 (taksoai-app@2.7.x).
 *
 * This is a focused single-step guide introducing the new completion
 * color specification for duct and pipe symbol rendering.
 */

import type { GuideStep } from './types';

export const GUIDE_STEPS_V27: GuideStep[] = [
  // ─── Step 0 — Color Spec Welcome ──────────────────────────────────────────
  {
    id: 'color-spec-welcome',
    index: 0,
    type: 'modal',
    routeScope: 'home',
    hideBack: true,
    title: "What's New in 2.7 — Completion Colors",
    description:
      "<p>We've updated to our new completion color guide for duct and pipe work.</p>" +
      '<p>Colors are used to quickly show progress at each stage of the workflow:</p>' +
      '<ul>' +
      '<li><strong>Red</strong> = No size or system information is available.</li>' +
      '<li><strong>Dark blue</strong> = Missing size details.</li>' +
      '<li><strong>Aqua</strong> = No system has been assigned.</li>' +
      '<li><strong>Yellow</strong> = All required information has been identified.</li>' +
      '<li><strong>Green</strong> = The work is fully completed and verified.</li>' +
      '</ul>',
    media: {
      kind: 'image',
      src: '/assets/symbol_color_spec_2026_sm.png',
      alt: 'Completion color legend for duct and pipe symbols',
    },
  },
];
